import { atom } from 'jotai'
import type { TFeelGreat } from '../../types/TFeelGreat'

const feelgreat: TFeelGreat = {
    additionalProducts: [],
    appPage: {
        title: { native: '', english: '' },
        isEnable: false,
        appImageUrl: '',
        description: { native: '', english: '' },
        secondTitle: { native: '', english: '' },
        appStoreLink: '',
        appDescription: { native: '', english: '' },
        googlePlayLink: '',
        appStoreImageUrl: null,
        googlePlayImageUrl: '',
        bannerImageMobileUrl: '',
        bannerImageDesktopUrl: ''
    },
    buyNowButton: {
        isEnable: false,
        buttonLink: { native: '', english: '' },
        buttonText: { native: '', english: '' },
        buttonType: '',
        buttonOpenTarget: ''
    },
    consent: {
        path: { native: '', english: '' },
        title: { native: '', english: '' },
        isEnable: false,
        imageUrls: { native: [], english: [] },
        usageType: '',
        openTarget: '',
        htmlContent: { native: '', english: '' },
        externalLink: { native: '', english: '' },
        handleFunction: { native: '', english: '' }
    },
    contact: {
        email: '',
        phone: '',
        isEnable: false
    },
    cookieSettings: {
        isEnable: false,
        cookieLink: { native: '', english: '' }
    },
    createYourAccount: {
        inputs: []
    },
    defaultValues: {
        purchaseOption: '',
        flavor: ''
    },
    description: { native: '', english: '' },
    descriptionLearnMore: null,
    disclaimer: null,
    expertsSay: null,
    flavors: [],
    freeItems: { items: [] },
    guilde: {
        image: '',
        title: { native: '', english: '' },
        isEnable: false,
        description: { native: '', english: '' }
    },
    guildeButton: {
        title: { native: '', english: '' },
        isEnable: false,
        usageType: '',
        path: { native: '', english: '' },
        openTarget: ''
    },
    howItWorks: {
        items: [],
        title: { native: '', english: '' },
        isEnable: false
    },
    images: [],
    is_show_same_day_delivery: false,
    is_show_same_day_delivery_VERBOSE: null,
    isCallOrderCalSuccess: false,
    isOverrideSkuByBAStatus: false,
    isShowCreateAccount: false,
    isShowReferralBox: false,
    learnPage: {
        faqs: { items: [], title: { native: '', english: '' }, isEnable: false },
        proTips: { items: [], isEnable: false },
        howToUse: {
            title: { native: '', english: '' },
            isEnable: false,
            mobileVersion: { items: [] },
            desktopVersion: { imageUrl: '', textItems: [] }
        },
        isEnable: false,
        sectionType: '',
        imageSection: {
            title: { native: '', english: '' },
            imageUrl: { native: '', english: '' },
            isEnable: false,
            textButton: { native: '', english: '' },
            description: { native: '', english: '' },
            buttonGoToUrl: '',
            isEnableButton: false
        },
        referSection: {
            title: { native: '', english: '' },
            imageUrl: '',
            isEnable: false,
            description_1: { native: '', english: '' },
            description_2: { native: '', english: '' }
        },
        videoSection: {
            title: { native: '', english: '' },
            isEnable: false,
            videoUrl: '',
            textButton: { native: '', english: '' },
            description: { native: '', english: '' },
            videoPoster: ''
        },
        threeSimpleSteps: { items: [], isEnable: false }
    },
    mainBanner: {
        image: '',
        title: { native: '', english: '' },
        isEnable: false,
        description: { native: '', english: '' },
        imageMobile: '',
        imageDesktop: ''
    },
    memberPriceUnlockReadMore: {
        titles: { native: [], english: [] },
        isEnable: false,
        subTitles: { native: [], english: [] },
        buttonText: { native: '', english: '' },
        paragraphs: { native: [], english: [] },
        buttonTitle: { native: '', english: '' },
        headerImage: ''
    },
    moneyBack: {
        titles: { native: [], english: [] },
        isEnable: false,
        subTitles: { native: [], english: [] },
        paragraphs: { native: [], english: [] }
    },
    moneyBackGuarantee: {
        titles: { native: [], english: [] },
        isEnable: false,
        subTitles: { native: [], english: [] },
        buttonText: { native: '', english: '' },
        paragraphs: { native: [], english: [] },
        headerImage: ''
    },
    notAvailable: null,
    order: {
        cart_message: { native: '', english: '' },
        cart_limit_qty: { native: '', english: '' },
        cart_message_2: { native: '', english: '' },
        cart_message_3: { native: '', english: '' },
        minimum_set_qty: { native: '', english: '' },
        cart_limit_price: { native: '', english: '' },
        minimum_item_qty: { native: '', english: '' },
        cart_limit_qty_total: { native: '', english: '' },
        cart_warning_qty_total: { native: '', english: '' },
        cart_warning_price_total: { native: '', english: '' },
        cart_warning_qty_per_item: { native: '', english: '' }
    },
    orderSummary: {
        isShowReferredBy: { onetime: false, subscription: false },
        isShowSubscriptionMessage: { onetime: false, subscription: false },
        isShowMemberDiscount: { onetime: false, subscription: false },
        isShowSubscriptionDiscount: { onetime: false, subscription: false },
        referredBy: { native: '', english: '' },
        subscriptionMessage: { native: '', english: '' }
    },
    ourApproach: {
        image: null,
        title: { native: '', english: '' },
        image2: { native: '', english: '' },
        isEnable: false,
        description: { native: '', english: '' }
    },
    passwordSettings: {
        isUseComplexPassword: false,
        isAllowChangePassword: false
    },
    privacyPolicy: {
        title: { native: '', english: '' },
        isEnable: false,
        usageType: '',
        htmlContent: { native: '', english: '' },
        externalLink: { native: '', english: '' },
        openTarget: ''
    },
    productCredit: { isEnable: false },
    products: {
        flavor_0: {
            onetime: {
                item_code: '',
                image_url: '',
                price: {
                    retail: 0,
                    member: 0,
                    associate: 0,
                    before: null,
                    after: 0,
                    onetime: 0,
                    subscription: 0,
                    __legacy: {
                        retail: 0,
                        member: 0,
                        before: null,
                        after: 0,
                        onetime: 0,
                        subscription: 0
                    }
                },
                discount: {
                    member: null,
                    associate: null,
                    subscription: null,
                    __legacy: { member: null, subscription: null }
                },
                qty: 0,
                flavor: {
                    value: '',
                    text: { native: '', english: '' },
                    description: { native: '', english: '' },
                    images: [],
                    titleInOrderSummary: null
                },
                pv: 0,
                status: '',
                tags: [],
                system_tags: [],
                weight: { unit: '', value: 0 }
            },
            subscribe: {
                item_code: '',
                image_url: '',
                price: {
                    retail: 0,
                    member: 0,
                    associate: 0,
                    before: null,
                    after: 0,
                    onetime: 0,
                    subscription: 0,
                    __legacy: {
                        retail: 0,
                        member: 0,
                        before: null,
                        after: 0,
                        onetime: 0,
                        subscription: 0
                    }
                },
                discount: {
                    member: null,
                    associate: null,
                    subscription: 0,
                    __legacy: { member: null, subscription: 0 }
                },
                qty: 0,
                flavor: {
                    value: '',
                    text: { native: '', english: '' },
                    description: { native: '', english: '' },
                    images: [],
                    titleInOrderSummary: null
                },
                pv: 0,
                status: '',
                tags: [],
                system_tags: [],
                weight: { unit: '', value: 0 }
            }
        }
    },
    purchaseOptions: [],
    questions: {
        title: { native: '', english: '' },
        isEnable: false,
        items: []
    },
    quickLinks: { items: [], isEnable: false },
    realResults: null,
    referralLinks: {
        feelgreat: { isEnable: false, allowStatuses: [] }
    },
    referralLinksSorted: [],
    referralLinksSorting: [],
    shippingAddress: { inputs: [] },
    social: {
        line: null,
        twitter: null,
        youtube: { native: '', english: '' },
        facebook: null,
        instagram: { native: '', english: '' },
        pinterest: null
    },
    socialStoriesGuidelines: {
        isEnable: false,
        usageType: '',
        htmlContent: { native: '', english: '' },
        externalLink: { native: '', english: '' }
    },
    termAndConditions: {
        path: { native: '', english: '' },
        title: { native: '', english: '' },
        isEnable: false,
        imageUrls: { native: [], english: [] },
        usageType: 'path',
        openTarget: '_self',
        htmlContent: { native: '', english: '' },
        externalLink: { native: '', english: '' },
        handleFunction: { native: '', english: '' }
    },
    termOfUse: {
        title: { native: '', english: '' },
        isEnable: false,
        usageType: '',
        externalLink: { native: '', english: '' },
        openTarget: ''
    },
    thePractice: {
        image: null,
        title: { native: '', english: '' },
        image2: { native: '', english: '' },
        isEnable: false,
        description: { native: '', english: '' }
    },
    theProducts: {
        items: [],
        title: { native: '', english: '' },
        isEnable: false
    }
}

export const feelgreatState = atom<TFeelGreat>(feelgreat)
